<template>
    <div class="lodingBox" v-if="scrollFlag || isEnd">
        <div v-if="scrollFlag">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <span>数据加载中，请稍后</span>
        </div>
        <div v-if="isEnd">
            <span>数据加载完成，没有更多相关内容了</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        scrollFlag: {
            type: Boolean,
            default: true
        },
        isEnd: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss" scoped>
.lodingBox {
    margin: 40px 0;
    width: 100%;
    text-align: center;
    .demo-spin-icon-load{
        margin-right: 10px;
        animation: ani-demo-spin 1s linear infinite;
    }
    span {
        font-size: 14px;
        font-family: Adobe Heiti Std;
        color: #333333;
    }
}
</style>